import { Component } from '@poa/core';
import { action, observable } from '@poa/state';
import moment from 'moment';
import Dropdown from '../dropdown';
import React from 'react';
import ReactDOM from 'react-dom';
import Spinner from 'react-spinkit';
import { DateRangePicker } from 'react-dates';
import { AreaChart, Area, XAxis, YAxis, Tooltip, ResponsiveContainer, BarChart, Bar } from 'recharts';
import { CHART_TYPE } from '../../store/shared-links/shared-links.constants';


const CustomTooltip = ( { active, payload, label, chartType }) => {

    if (active && payload && payload.length > 0) {
        return (
            <div className="chart-tooltip">
                <h5>{label}</h5>
                <br />
                <h4>
                    {
                        (chartType === "earnings") && ("$ ")
                    }{payload[0].value}
                </h4>
            </div>
        );
    } else {
        return null;
    }
}

const CustomizedAxisTick = props => {
    const { x, y, payload } = props;
    return (
        <g transform={`translate(${x},${y})`}>
            <text
                x={0}
                y={0}
                dy={16}
                textAnchor="end"
                fill="#52525B"
                color="#52525B"
                fontSize="12"
                fontWeight="400"
            >
                {moment(payload.value, "DD.MM.YYYY").locale('ru').format('D MMMM')}
            </text>
        </g>
    );
};

const modalEl = document.getElementById('modal');

export class ShareLinkChartModal extends React.Component {

    static defaultProps = {
        isOpened: true,
        linkId: 0
    };

    render() {
        const { isOpened, ...rest } = this.props;

        if (isOpened) {
            return ReactDOM.createPortal(<Modal {...rest} />, modalEl);
        }

        return null;
    }
}

const Modal = Component()(

    class Modal extends React.Component {
        store; // injected by Poa
        actions; // injected by Poa
        t; // injected by Poa

        componentWillUnmount() {
            document.body.classList.remove('no-scroll');
        }

        handleOutsideClick = e => {
            if (this.node && this.node.contains(e.target)) {
                return;
            }
            this.onClose();
        };


        localState = observable({
            loading: false,
            barChart: false,
            chartType: CHART_TYPE.EARNINGS,
            getProps: () => this.props,

        });

        focusedDateInput = observable(null);

        handleDatepickerFocusChange = focusedInput => this.focusedDateInput.set(focusedInput);

        onDatesChange = async ({ startDate, endDate }) => {
            this.actions.shareLinksActions.setDates({startDate, endDate});
            this.onChartDataChange(this.localState.chartType)
        };

        onChartDataChange = async ( chartType ) => {
            let selectedFilter = this.store.shareLinks.filters.filtering.selected.value;
            this.localState.chartType = chartType;

            if ((chartType === CHART_TYPE.EARNINGS || chartType === CHART_TYPE.CUMULATIVE_ERANINGS) && (selectedFilter !== "earnings")) {
                this.store.shareLinks.filters.filtering.selected = this.store.shareLinks.filters.filtering.options.find(f => f.value === "earnings");
            } else if ((chartType === CHART_TYPE.SUBS || chartType === CHART_TYPE.CUMULATIVE_SUBS) && (selectedFilter !== "fans")) {
                this.store.shareLinks.filters.filtering.selected = this.store.shareLinks.filters.filtering.options.find(f => f.value === "fans");
            }
            this.actions.shareLinksActions.setChartType({chartType});
        };

        onFilteringChange = action(selected => {
            this.store.shareLinks.filters.filtering.selected = selected;
            if (selected.value === "earnings") {
                this.localState.chartType = CHART_TYPE.EARNINGS;
            } else {
                this.localState.chartType = CHART_TYPE.SUBS;
            }
            this.onChartDataChange(this.localState.chartType);
        });

        renderOption(d, i, selected, onClick) {
            let className = 'common-filter__btn';

            if (selected === d) {
                className += ' is-active';
            }

            return (
                <button key={i} className={className} onClick={() => onClick(d)}>
                    {d.label}
                </button>
            );
        }

        renderFilteringOption = (d, i) => {
            return this.renderOption(d, i, this.store.shareLinks.filters.filtering.selected, this.onFilteringChange);
        };

        onClose = action(() => {
            this.props.requestClose();
        });

        onChartTypeChange = action((isBar) => {
            this.localState.barChart = isBar;
        });

        isMobile = () => window.matchMedia('(max-width: 767px)').matches;


        render() {
            const {payments, filters, data, claimsQty, revenue} = this.store.shareLinks;
            const isMobile = this.isMobile();

            return (
                <div
                    className='share-link-popup'
                    onClick={this.handleOutsideClick}
                >
                    <div ref={node => (this.node = node)}>
                        <div className='body'>
                            <div className='header'>

                                {
                                    this.localState.loading ? (
                                        <div
                                            className="spinner-loading"
                                            style={{ paddingTop: '5px', textAlign: 'center' }}
                                        >
                                            <Spinner name="folding-cube" fadeIn="none" />
                                        </div>
                                    ) : (
                                        <>
                                            <div>{data.link_name}</div>
                                            <div className='separator'></div>
                                            <div><span>{data.created_at_short}</span></div>
                                            <div className='separator'></div>
                                            <div>{data.claimes_qty} <span>subs</span></div>
                                            <div className='separator'></div>
                                            <div><h2>$ {data.revenue}</h2><span>({data.revenue_from} fans)</span></div>
                                        </>
                                    )
                                }
                            </div>

                            <div className='content'>

                                <div className='content__header'>
                                    <div className='filter'>
                                        <DateRangePicker
                                            orientation={isMobile ? 'vertical' : 'horizontal'}
                                            disabled={false}
                                            startDateId='1'
                                            endDateId='1'
                                            isOutsideRange={() => false}
                                            startDate={filters.startDate}
                                            startDatePlaceholderText={this.t('from')}
                                            endDate={filters.endDate}
                                            endDatePlaceholderText={this.t('to')}
                                            onDatesChange={this.onDatesChange}
                                            focusedInput={this.focusedDateInput.get()}
                                            onFocusChange={this.handleDatepickerFocusChange}
                                            customArrowIcon='-'
                                            minimumNights={0}
                                            hideKeyboardShortcutsPanel={true}
                                        />
                                    </div>

                                    {
                                        !isMobile && (
                                            <div className='chart-buttons'>
                                        <button
                                            className={`common-filter__btn ${this.localState.barChart ? 'is-active' : ''}`}
                                            onClick={() => this.onChartTypeChange(true)}
                                        >
                                            Bar
                                        </button>
                                        <button
                                            className={`common-filter__btn ${!this.localState.barChart ? 'is-active' : ''}`}
                                            onClick={() => this.onChartTypeChange(false)}
                                        >
                                            Line
                                        </button>
                                    </div> 
                                        )
                                    }
                                    <Dropdown
                                        label={isMobile ? null : this.t('filtering') }
                                        selected={filters.filtering.selected.label}>
                                        {filters.filtering.options.map(this.renderFilteringOption)}
                                    </Dropdown>
                                </div>


                                <div className='content__content'>
                                    {
                                        this.localState.loading ? (
                                            <div
                                                className="spinner-loading"
                                                style={{ paddingTop: '5px', textAlign: 'center' }}
                                            >
                                                <Spinner name="folding-cube" fadeIn="none" />
                                            </div>
                                        ) : (
                                            <>
                                                <div className='header'>
                                                    <button onClick={() => this.onChartDataChange(CHART_TYPE.EARNINGS)}>
                                                        <h2>$ {Number(revenue.toFixed(2))}</h2><span>Net Earnings</span>
                                                    </button>
                                                    <button onClick={() => this.onChartDataChange(CHART_TYPE.CUMULATIVE_ERANINGS)}>
                                                        <h2>$ {Number(revenue.toFixed(2))}</h2><span>Cumulative net earnings</span>
                                                    </button>
                                                    <button onClick={() => this.onChartDataChange(CHART_TYPE.SUBS)}>
                                                        <h2>{claimsQty}</h2><span>New Subs</span>
                                                    </button>
                                                    <button onClick={() => this.onChartDataChange(CHART_TYPE.CUMULATIVE_SUBS)}>
                                                        <h2>{claimsQty}</h2><span>Cumulative New Subs</span>
                                                    </button>
                                                </div>

                                                {payments[filters.filtering.selected.value].length === 0 ?
                                                    <div className='content-chart'>No data</div>
                                                :

                                                <div className='content-chart'>
                                                    <ResponsiveContainer minWidth={300} height={300}>

                                                        {this.localState.barChart ? 
                                                        (
                                                            <BarChart
                                                                data={payments[filters.filtering.selected.value]}
                                                                margin={{
                                                                    top: 2,
                                                                    right: 0,
                                                                    left: 0,
                                                                    bottom: 0,
                                                                }}
                                                            >
                                                                <XAxis dataKey="date" tick={<CustomizedAxisTick />} />
                                                                <Tooltip content={<CustomTooltip  chartType={filters.filtering.selected.value}/>} />
                                                                <YAxis />
                                                                <Bar 
                                                                    dataKey="total"
                                                                    stroke="#5B668D"
                                                                    fill="#F5F7FF"
                                                                />
                                                            </BarChart>

                                                        )
                                                        : (
                                                        <AreaChart
                                                            data={payments[filters.filtering.selected.value]}
                                                            margin={{
                                                                top: 2,
                                                                right: 0,
                                                                left: 10,
                                                                bottom: 0,
                                                            }}
                                                        >
                                                            <XAxis dataKey="date" tick={<CustomizedAxisTick />} />
                                                            <YAxis />
                                                            <Tooltip content={<CustomTooltip chartType={filters.filtering.selected.value}/>} />
                                                            <Area
                                                                type="linear"
                                                                dataKey="total"
                                                                stroke="#5B668D"
                                                                fill="#F5F7FF" />
                                                        </AreaChart>
                                                        )}
                                                    </ResponsiveContainer>
                                                </div>
                                                }

                                            </>
                                        )
                                    }
                                </div>


                                <div className='content__footer'>
                                    <button onClick={this.onClose}>Close</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            );
        }
    }
);
